import React, { useContext } from 'react';
import { MenuItem, MenuList, Paper, Popover, Typography } from '@material-ui/core';
import CmtAvatar from '../../../../@coremat/CmtAvatar';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { AuhMethods } from '../../../../services/auth';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SidebarThemeContext from '../../../../@coremat/CmtLayouts/SidebarThemeContext/SidebarThemeContext';
import { closedBrowser, removeAccountForAction } from 'redux/actions/Accounts';

const useStyles = makeStyles(theme => ({
    root: {
        display : "flex",
        gap: 10,
        borderBottom: props => `solid 1px ${props.sidebarTheme.borderColor}`,
        alignItems: "center"
    },
    userInfo: {
        paddingTop: 12,
        transition: 'all 0.1s ease',
        height: 75,
        opacity: 1,
        '.Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &': {
            height: 0,
            paddingTop: 0,
            opacity: 0,
            transition: 'all 0.3s ease',
        },
        width: "100%"
    },
    userTitle: {
        color: props => props.sidebarTheme.textDarkColor,
        marginBottom: 8,
    },
    userSubTitle: {
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
        letterSpacing: 0.25,
    },
}));

const SidebarHeader = () => {
    const { sidebarTheme } = useContext(SidebarThemeContext);
    const classes = useStyles({ sidebarTheme });
    const dispatch = useDispatch();
    const { authUser } = useSelector(({ auth }) => auth);
    const { dataAccounts } = useSelector(({ manageAccountFacebook }) => manageAccountFacebook);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const onLogoutClick = () => {
        handlePopoverClose();
        dataAccounts.forEach(account => {
            if (account.state !== 0 || account.state !== undefined) {
                dispatch(closedBrowser(account));
            }
            dispatch(removeAccountForAction(account));
        });
        dispatch(AuhMethods[CurrentAuthMethod].onLogout());
    };

    return (
        <div className={classes.root}>
            <CmtAvatar src={'https://via.placeholder.com/150'} alt="User Avatar" />
            <div className={classes.userInfo} onClick={handlePopoverOpen}>
                <div
                    className="pointer"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}>
                    <div className="mr-2">
                        <Typography className={classes.userTitle} component="h3" variant="h6">
                            {authUser ? authUser.phone : ''}
                        </Typography>
                        <Typography className={classes.userSubTitle}>{authUser ? authUser.name : ''}</Typography>
                    </div>
                    <ArrowDropDownIcon />
                </div>
            </div>
            {open && (
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    container={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}>
                    <Paper elevation={8}>
                        <MenuList>
                            {/* <MenuItem onClick={handlePopoverClose}>
                <PersonIcon />
                <div className="ml-2">Profile</div>
              </MenuItem>
              <MenuItem onClick={handlePopoverClose}>
                <SettingsIcon />
                <div className="ml-2">Settings</div>
              </MenuItem> */}
                            <MenuItem onClick={onLogoutClick}>
                                <ExitToAppIcon />
                                <div className="ml-2">Logout</div>
                            </MenuItem>
                        </MenuList>
                    </Paper>
                </Popover>
            )}
        </div>
    );
};

export default SidebarHeader;
